import { BookingStepsContextState } from '../../context/bookingContext/bookingContext.types';
import {
  BookingConfig,
  BookingStepValueEnum,
  BookingSubStepValueEnum,
} from '../BookingWidget/bookingSteps.interface';
import { getSubscriberObject } from '../../shared/helpers/subscriber.helper';
import getBeneficiariesArray from '../../shared/helpers/beneficiaries.helper';
import getInsurancePayload from '../../shared/helpers/getInsurancePayload.helper';
import {
  PricingCapturePayload,
  PricingCapturePayloadEnum,
  PricingPayload,
  PricingPayloadEnum,
  ProductsEnum,
} from './pricingPayload.interfaces';
import { BookingDataResponse } from '../BookingWidget/BookingManagment/bookingManagment.interface';
import { BookingQuoteResponse } from '../BookingWidget/BookingQuoteManagment/bookingQuoteResponse.interface';
import { getQuoteId } from '../../shared/helpers/quote.helper';
import { DecodedSessionToken } from '../../context/sessionContext/sessionContext.interface';
import { BookingQuoteBeneficiaries } from '../BookingWidget/BookingQuoteManagment/bookingQuote.interface';

const getBeneficiariesForPricingPayload = (
  bookingSteps: BookingStepsContextState,
  bookingConfigData: BookingConfig,
  bookingDataResponse: BookingDataResponse | null,
): BookingQuoteBeneficiaries[] => {
  const beneficiaries = getBeneficiariesArray(
    bookingSteps,
    bookingConfigData,
    bookingDataResponse,
    {
      inferDateOfBirth: true,
      skipAge: true,
    },
  );

  // Remove age property from each beneficiary
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return beneficiaries.map(({ age, ...beneficiary }) => beneficiary);
};

const preparePricingPayload = (
  bookingSteps: BookingStepsContextState,
  bookingConfigData: BookingConfig,
  bookingDataResponse: BookingDataResponse | null,
  bookingQuoteResponse: BookingQuoteResponse | null,
  decodedSessionToken: DecodedSessionToken | null,
): PricingPayload => ({
  [PricingPayloadEnum.Products]: [
    {
      [ProductsEnum.Reference]: '01',
      [ProductsEnum.ProductGroup]: [
        {
          code: `${
            bookingSteps[BookingStepValueEnum.QuotationProposals][
              BookingSubStepValueEnum.Proposal
            ].code
          }`,
        },
      ],
    },
  ],
  [PricingPayloadEnum.Insurance]: getInsurancePayload(
    bookingSteps,
    bookingConfigData,
    bookingQuoteResponse,
    null,
    decodedSessionToken,
  ),
  [PricingPayloadEnum.Subscriber]: getSubscriberObject(
    bookingConfigData,
    bookingSteps,
  ),
  [PricingPayloadEnum.Beneficiaries]: getBeneficiariesForPricingPayload(
    bookingSteps,
    bookingConfigData,
    bookingDataResponse,
  ),
  [PricingPayloadEnum.Promotion]: {
    promotionCode:
      bookingSteps.quotationForm[BookingSubStepValueEnum.PromoCode],
  },
  [PricingPayloadEnum.CatalogVersion]:
    bookingDataResponse?.bookingData.catalogVersion ?? '',
});

export const prepareCapturePricingPayload = (
  bookingSteps: BookingStepsContextState,
  bookingConfigData: BookingConfig,
  bookingDataResponse: BookingDataResponse | null,
  bookingQuoteResponse: BookingQuoteResponse | null,
  decodedSessionToken: DecodedSessionToken | null,
): PricingCapturePayload => ({
  [PricingCapturePayloadEnum.PSPayload]: preparePricingPayload(
    bookingSteps,
    bookingConfigData,
    bookingDataResponse,
    bookingQuoteResponse,
    decodedSessionToken,
  ),
  [PricingCapturePayloadEnum.QuoteId]: getQuoteId(bookingQuoteResponse),
});

export default preparePricingPayload;
